module.exports = __webpack_public_path__ + "static/media/Spend.aee9474c.svg";